// extracted by mini-css-extract-plugin
export default {"container":"Team_container__Wbhxc","header-wrapper":"Team_header-wrapper__+h699","title":"Team_title__8Q432","content-wrapper":"Team_content-wrapper__MUh4d"};